
import React, { useEffect, useState } from 'react';
import {
    Alert, Autocomplete, Button, Checkbox, Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle, Fab, FormControl, Grid, IconButton, InputAdornment,
    InputBase, InputLabel, MenuItem, Paper, Select, Snackbar, TextField,
    Typography
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import { useParams } from 'react-router-dom';
import AutocompleteList from '../../utils/componentes-utiles/AutocompleteList';
import { AlertError } from '../../utils/componentes-utiles/AlertError';
import { postTareaTaller } from '../../services/apis';


export const FormCrearTareaTaller = ({ open, setOpen, estados, tareaInfo, handleEvent, backgroundCard, textColor, opclientes, cargarTareas, opTrabajadores }) => {
    const handleClose = () => {
        setOpen(false);
    };

    const param = useParams();
    const [errorAlert, setErrorAlert] = useState(false);
    const [clienteSelec, setClienteSelec] = useState({ label: "Seleccione un Cliente", value: "0" });
    const [trabajadorSelec, setTrabajadorSelec] = useState([]);
    const [archivos, setArchivos] = useState([]);
    const fecha = new Date();
    fecha.setHours(fecha.getHours() + 1);
    const [tarea, setTarea] = useState({
        'fecha': fecha,
        'asunto': '',
        'descripcion': '',
        'localizacion': '',
        'id_cliente': null,
        'minutos': '',
        'cargador': null,
        'funda': null,
        'maletin': null,
        'tipo_parte': null,
        'id_estado': 0,
        'nombre_cliente': null,
        'telefono': null,
        'correo': null,
        'presupuesto': null,
        'iva': 1,
        'comentario_presupuesto': null,

    });

    const handleChange = (event) => {
        const tareaNueva = { ...tarea, [event.target.name]: event.target.value };
        setTarea(tareaNueva);
        setErrorAlert(false)
    };


    const handleArchivoChange = (event) => {
        setArchivos((prevArchivos) => [
            ...prevArchivos,
            ...Array.from(event.target.files) // Agregar los nuevos archivos
        ]);
    };

    const isNullInObject = (obj) => {
        // Lista de campos que se deben omitir en la validación
        let camposExcepcion = [];
        if (tarea.tipo_parte == 1) {
            camposExcepcion = ['localizacion', 'minutos', 'id_cliente', 'trabajadores', 'id_estado', 'correo', 'presupuesto', 'iva', 'comentario_presupuesto'];
        } else {
            camposExcepcion = ['localizacion', 'minutos', 'id_cliente', 'trabajadores', 'id_estado', 'cargador', 'funda', 'maletin', 'contrasena', 'dispositivo', 'correo', 'presupuesto', 'iva', 'comentario_presupuesto'];
        }

        return Object.keys(obj).every(key => {
            if (camposExcepcion.includes(key)) {
                return true;
            }
            return obj[key] !== null && obj[key] !== '' && obj[key] != 0;
        });
    };

    const crearTarea = async () => {
        const nuevaTareaTmp = { ...tarea };
        nuevaTareaTmp.id_cliente = clienteSelec.value;
        nuevaTareaTmp.trabajadores = trabajadorSelec;

        const tareaComprobada = isNullInObject(nuevaTareaTmp);

        if (!tareaComprobada) {
            console.error("Hay campos vacíos o no válidos en la tarea");
            setErrorAlert(true);
            return; // Detener la ejecución si hay campos no válidos
        }

        try {

            const response = await postTareaTaller(nuevaTareaTmp, archivos);
            if (response.success === true) {
                handleClose();

                cargarTareas();
                setTarea(
                    {
                        'fecha': new Date(),
                        'asunto': '',
                        'descripcion': '',
                        'localizacion': '',
                        'id_cliente': null,
                        'minutos': '',
                        'cargador': null,
                        'funda': null,
                        'maletin': null,
                        'tipo_parte': null,
                        'id_estado': 0,
                        'nombre_cliente': null,
                        'telefono': null,
                        'correo': null,
                        'presupuesto': null,
                        'iva': 1,
                        'comentario_presupuesto': null,
                    });
                setClienteSelec({ label: "Seleccione un Cliente", value: "0" });
                setArchivos(null)
                setTrabajadorSelec([]);
                handleClose();

            }
        } catch (error) {
            console.error("Error al cargar tareas", error);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        crearTarea();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            aria-describedby="form-dialog-description"
            fullWidth
            maxWidth="lg"
        >
            <DialogContent style={{
                backgroundColor: `#${backgroundCard}`,
                color: textColor
            }}>

                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    xs={12}
                    sx={{ mb: 3 }}
                >
                    <Typography variant="h6">Crear Nueva Tarea</Typography>

                    <CancelIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
                </Grid>

                <form onSubmit={handleSubmit}>

                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                        gap={2}
                        sx={{ mb: 3 }}
                    >
                        <Grid item xs={12} md={5}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Tipo de parte</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="tipo_parte"
                                    label="Tipo de parte"
                                    value={tarea.tipo_parte} // Asegura un valor predeterminado
                                    onChange={handleChange}
                                    fullWidth
                                >
                                    <MenuItem value={1}>Dispositivo</MenuItem>
                                    <MenuItem value={2}>Otro</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <Autocomplete
                                fullWidth
                                className={opclientes ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                options={opclientes}
                                value={clienteSelec}
                                onChange={(event, newValue) => setClienteSelec(newValue)}
                                renderInput={(params) => <TextField {...params} label="Obligatorio*" />}
                            />
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <TextField
                                label="Fecha"
                                type="date"
                                id="dateInput"
                                name="fechaDesde"
                                // className={filtros.fechaDesde ? "inputDateInput" : 'inputDateInput-empty'}
                                required
                                value={new Date().toISOString().split('T')[0]} // Se establece la fecha de hoy si compra.Fecha es null
                                onChange={handleChange}
                                fullWidth
                            />
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <TextField
                                label="Nombre Cliente"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="nombre_cliente"
                                value={tarea.nombre_cliente}
                                onChange={handleChange}
                                required
                            />
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <TextField
                                label="Telefono"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="telefono"
                                value={tarea.telefono}
                                onChange={handleChange}
                                required
                            />
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <TextField
                                label="Correo"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="correo"
                                value={tarea.correo}
                                onChange={handleChange}
                            />
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <TextField
                                label="Asunto"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="asunto"
                                value={tarea.asunto}
                                onChange={handleChange}
                                required
                            />
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <TextField
                                label="contraseña"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="contrasena"
                                value={tarea.contrasena}
                                onChange={handleChange}
                                required={tarea.tipo_parte === 1 ? true : false}
                            />
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <TextField
                                label="Dispositivo"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="dispositivo"
                                value={tarea.dispositivo}
                                onChange={handleChange}
                                required={tarea.tipo_parte === 1 ? true : false}
                            />
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Estado</InputLabel>
                                <Select
                                    label="Estado"
                                    id="demo-simple-select-standard"
                                    labelId="demo-simple-select-filled-label"
                                    name="id_estado"
                                    value={tarea.id_estado}
                                    defaultValue={0}
                                    onChange={handleChange}
                                    fullWidth

                                >
                                    {estados.map((estado) => (
                                        <MenuItem key={estado.id} value={estado.id}>{estado.nombre}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        {/* <Grid item>
                            <AutocompleteList array={opTrabajadores} setArray={setTrabajadorSelec} />
                        </Grid> */}
                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                        gap={1}
                        sx={{ mb: 3 }}
                    >

                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="center"
                            xs={12} md={5}
                        >
                            <InputLabel id="demo-simple-select-label">Presupuesto</InputLabel>
                            <Grid container xs={12} justifyContent={'center'} direction={'row'} borderRadius={1} padding={2} gap={2} style={{ backgroundColor: 'white', borderRadius: '5px', border: '1px solid rgb(189, 189, 189)' }}>
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    xs={12}
                                >
                                    <Grid item xs={8}>
                                        <TextField
                                            label="Presupuesto en €"
                                            variant="outlined"
                                            multiline
                                            fullWidth
                                            name="presupuesto"
                                            value={tarea.presupuesto}
                                            onChange={handleChange}
                                        />
                                    </Grid>

                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel id="estado-select-label">IVA</InputLabel>
                                            <Select
                                                labelId="estado-select-label"
                                                id="estado-select"
                                                name="iva"
                                                label="IVA"
                                                value={tarea.iva} // Asegura un valor predeterminado
                                                onChange={handleChange}
                                            >
                                                <MenuItem value={1}>Si</MenuItem>
                                                <MenuItem value={2}>No</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                </Grid>

                                <Grid container xs={12} justifyContent={'center'} alignItems={'center'}>
                                    <TextField
                                        label="Comentario Presupuesto"
                                        variant="outlined"
                                        multiline
                                        fullWidth
                                        name="comentario_presupuesto"
                                        value={tarea.comentario_presupuesto}
                                        onChange={handleChange}
                                        required={tarea.id_estado >= 2 && tarea.id_estado <= 5 || tarea.id_estado == 7 ? true : false}

                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="center"
                            xs={12} md={5}
                        >
                            <InputLabel id="demo-simple-select-label">Elementos entregados</InputLabel>
                            <Grid container xs={12} justifyContent={'center'} direction={'row'} borderRadius={1} padding={2} style={{ backgroundColor: 'white', borderRadius: '5px', border: '1px solid rgb(189, 189, 189)' }}>
                                <Grid container xs={4} justifyContent={'center'} marginBottom={"1em"} >
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Cargador</InputLabel>

                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            name="cargador"
                                            label="Cargador"
                                            value={tarea.cargador} // Asegura un valor predeterminado
                                            onChange={handleChange}

                                        >
                                            <MenuItem value={1}>No</MenuItem>
                                            <MenuItem value={2}>Sí</MenuItem>
                                        </Select>
                                    </FormControl>

                                </Grid>
                                <Grid container xs={4} justifyContent={'center'} marginBottom={"1em"}>
                                    <FormControl fullWidth>

                                        <InputLabel id="demo-simple-select-label">Funda</InputLabel>

                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            name="funda"
                                            label="Funda"
                                            value={tarea.funda} // Asegura un valor predeterminado
                                            onChange={handleChange}

                                        >
                                            <MenuItem value={1}>No</MenuItem>
                                            <MenuItem value={2}>Sí</MenuItem>
                                        </Select>
                                    </FormControl>

                                </Grid>
                                <Grid container xs={4} justifyContent={'center'} marginBottom={"1em"} >
                                    <FormControl fullWidth>

                                        <InputLabel id="demo-simple-select-label">Maletin/Bolsa</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            name="maletin"
                                            label="Maletin/Bolsa"
                                            value={tarea.maletin} // Asegura un valor predeterminado
                                            onChange={handleChange}

                                        >
                                            <MenuItem value={1}>No</MenuItem>
                                            <MenuItem value={2}>Sí</MenuItem>
                                        </Select>
                                    </FormControl>

                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    xs={12}
                                >
                                    <Grid item xs={8}>
                                        <TextField
                                            label="Otro elemento"
                                            variant="outlined"
                                            multiline
                                            fullWidth
                                            name="otorelemento"
                                            value={tarea.otorelemento}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Grid>

                                    <Grid item xs={2.5}>
                                        <Fab size='medium' color="primary">
                                            <AddIcon />
                                        </Fab>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>

                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        xs={12}
                    >
                        <TextField
                            label="Descripción"
                            variant="outlined"
                            multiline
                            rows={4}
                            fullWidth
                            name="descripcion"
                            value={tarea.descripcion}
                            onChange={handleChange}
                            required
                        />
                    </Grid>

                    <Grid item>
                        {/* <Button variant="contained" component="label">
                            Subir Archivos
                            <input
                                type="file"
                                hidden
                                multiple
                                onChange={handleArchivoChange}
                            />
                        </Button>

                        {archivos && archivos.length > 0 && (
                            <div style={{ marginTop: '10px' }}>
                                {archivos.map((archivo, index) => (
                                    <span key={index} style={{ display: 'block' }}>
                                        {archivo.name}
                                    </span>
                                ))}
                            </div>
                        )} */}
                    </Grid>
                </form>
            </DialogContent>

            <DialogActions style={{
                backgroundColor: `#${backgroundCard}`,
                color: textColor
            }}>
                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained">
                    Crear Tarea
                </Button>
            </DialogActions>
            {
                errorAlert && (
                    <AlertError open={errorAlert} setOpen={setErrorAlert} titulo={"Error"} mensaje={"Falta rellenar algún campo obligatorio"} />
                )
            }
        </Dialog >
    );
};
